import {
    FETCH_ATTENDANCE_REQUEST,
    FETCH_ATTENDANCE_SUCCESS,
    FETCH_ATTENDANCE_FAILURE,
    FETCH_LOCATIONS_REQUEST,
    FETCH_LOCATIONS_SUCCESS,
    FETCH_LOCATIONS_FAILURE,
  } from "../actions/jobHistoryAllAction";
  
  const initialState = {
    attendance: [],
    locations: [],
    loading: false,
    error: null,
  };
  
  export const attendanceReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ATTENDANCE_REQUEST:
      case FETCH_LOCATIONS_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_ATTENDANCE_SUCCESS:
        return {
          ...state,
          loading: false,
          attendance: action.payload || [],
        };
      
  
      case FETCH_LOCATIONS_SUCCESS:
        return { ...state, locations: action.payload };
        
  
      case FETCH_ATTENDANCE_FAILURE:
      case FETCH_LOCATIONS_FAILURE:
        return { ...state, loading: false, error: action.error };
  
      default:
        return state;
    }
  };
  